
import { Grid } from "@mui/material";
import WebRTCPlayer from "./WebRTC/WebRTCPlayer";


interface VideoTabProps {
    stream: string;
    video_server?: string;
    channel_id?: string;
    authToken?: string;
}

export const VideoTab = ({
    stream,
    video_server,
    channel_id,
    authToken
} : VideoTabProps) => {
    console.log("=== VIDEOTAB: Received props ===");
    console.log("stream:", stream);
    console.log("video_server:", video_server);
    console.log("channel_id:", channel_id);
    console.log("authToken:", authToken);

    // Don't render if any required parameters are undefined
    if (!stream || !video_server || !channel_id || !authToken) {
        console.log("VideoTab: Missing required parameters, not rendering");
        return null;
    }
    
    console.log("VideoTab: Rendering WebRTCPlayer with all parameters");

    return (
    <Grid>
    <WebRTCPlayer 
            video_server = {video_server}
            stream_id = {stream}
            channel_id = {channel_id}
            authToken = {authToken}
            
    />

    </Grid>
    )
}
